import { render, staticRenderFns } from "./MapaAtendimentos.vue?vue&type=template&id=5378c688"
import script from "./MapaAtendimentos.vue?vue&type=script&lang=js"
export * from "./MapaAtendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports